import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataDictionaryExportSlice } from './post';

export const coreDataDictionaryExportReducers = combineReducers({
	post: postCoreDataDictionaryExportSlice.asyncReducers
});

export const coreDataDictionaryExportWatchers = combineAllWatchers([ postCoreDataDictionaryExportSlice.asyncWatchers ]);
